import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";

import { TanStackReactQueryDevelopmentTools } from "../components/developmentTools";
import { ThemeProvider, Toaster, TooltipProvider } from "../components/ui";

import { AuthProvider } from "./auth";
import { queryClient, router } from "./router";

const Router = () => {
  return (
    <RouterProvider
      router={router}
      context={{ queryClient }}
    />
  );
};

export const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TanStackReactQueryDevelopmentTools
        initialIsOpen={false}
        buttonPosition="bottom-right"
      />
      <ThemeProvider>
        <Toaster />
        <TooltipProvider>
          <AuthProvider>
            <Router />
          </AuthProvider>
        </TooltipProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
};
